module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/trash-5c7c2ae4f836aff52925bcbd81f7aefe.svg";